import React, { Component } from "react";
import axios from "axios";
import * as appConst from "./constants";

class Support extends Component {
  constructor(props) {
    super(props);
    this.state = { validTill: "", todayAPI: "" };
  }

  componentDidMount() {
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) + "/center/edit"
      )
      .then(response => {
        this.setState({
          validTill: response.data.validTill,
          todayAPI: response.data.todayAPI
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  render() {
    return (
      <div>
        <h3 align="center">Support</h3>
        <div className="container-fluid">
          <div className="row p-1 border">
            <div className="col col-md-3">Email</div>
            <div className="col col-md-6">shakeebmm@gmail.com</div>
          </div>
          <div className="row p-1 border">
            <div className="col col-md-3">WhatsApp</div>
            <div className="col col-md-6">+91 9986 002121</div>
          </div>
          <div className="row p-1 border">
            <div className="col col-md-3">Today</div>
            <div className="col col-md-6">{this.state.todayAPI}</div>
          </div>
          <div className="row p-1 border">
            <div className="col col-md-3">Expiry Date</div>
            <div className="col col-md-6">{this.state.validTill}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default Support;
